"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var radium_1 = require("radium");
var context_1 = require("../../context");
var Paging = /** @class */ (function (_super) {
    __extends(Paging, _super);
    function Paging() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Paging.prototype.render = function () {
        var _this = this;
        return (React.createElement(context_1.THEME_CONTEXT.Consumer, null, function (theme) {
            var compiledStyles = styles(theme);
            var getLi = function (page, offset, count, caption, onClick) {
                return (React.createElement("li", { key: page, style: __assign({}, compiledStyles.li, (page - 1 === offset / count ? compiledStyles.active : null)), onClick: function () { onClick((page - 1) * count); } }, caption));
            };
            var _a = _this.props, offset = _a.offset, total = _a.total, pageSize = _a.pageSize, onClick = _a.onClick;
            if (total <= pageSize) {
                return null;
            }
            var page = offset / pageSize + 1;
            var pageCount = Math.floor(total / pageSize) + (total % pageSize === 0 ? 0 : 1);
            var items = [];
            if (pageCount <= 10) {
                for (var i = 1; i <= pageCount; i += 1) {
                    items.push(getLi(i, offset, pageSize, i, onClick));
                }
            }
            else if (page <= 3) {
                for (var i = 1; i <= 5; i += 1) {
                    items.push(getLi(i, offset, pageSize, i, onClick));
                }
                items.push(React.createElement("li", { key: "-1", style: compiledStyles.disabled }, "..."));
                items.push(getLi(pageCount, offset, pageSize, 'start', onClick));
            }
            else if (page >= pageCount - 2) {
                items.push(getLi(1, offset, pageSize, 'end', onClick));
                items.push(React.createElement("li", { key: "-1", style: compiledStyles.disabled }, "..."));
                for (var i = pageCount - 4; i <= pageCount; i += 1) {
                    items.push(getLi(i, offset, pageSize, i, onClick));
                }
            }
            else {
                items.push(getLi(1, offset, pageSize, 'recent', _this.props.onClick));
                items.push(React.createElement("li", { key: "-2", style: compiledStyles.disabled }, "..."));
                for (var i = page - 2; i <= page + 2; i += 1) {
                    items.push(getLi(i, offset, pageSize, i, _this.props.onClick));
                }
                items.push(React.createElement("li", { key: "-1", style: compiledStyles.disabled }, "..."));
                items.push(getLi(pageCount, offset, pageSize, 'early', _this.props.onClick));
            }
            return (React.createElement("ul", { style: compiledStyles.container }, items));
        }));
    };
    Paging = __decorate([
        radium_1.default
    ], Paging);
    return Paging;
}(React.Component));
exports.Paging = Paging;
var styles = function (theme) { return ({
    container: {
        display: 'flex',
        alignItems: 'center',
        margin: 0,
        padding: 0,
    },
    li: {
        padding: theme.paging.item.padding,
        borderRadius: theme.paging.item.borderRadius,
        background: theme.common.primaryBoxBackground,
        color: theme.common.primaryTextColor,
        border: theme.paging.item.border,
        fontSize: theme.paging.item.fontSize,
        margin: theme.paging.item.margin,
        listStyleType: 'none',
        cursor: 'pointer',
        //
        ':hover': {
            color: 'red',
            background: theme.common.secondaryBoxBackground,
        },
    },
    active: {
        background: theme.common.secondaryBoxBackground,
        fontWeight: 'bold',
    },
    disabled: {
        listStyleType: 'none',
        color: theme.common.secondaryTextColor,
        margin: theme.paging.item.margin,
    },
}); };
